import {
    Box,
    BoxProps,
    Button,
    Card,
    CardBody,
    CardHeader,
    Image,
    SimpleGrid,
    Text,
} from '@chakra-ui/react';
import { PropsWithChildren, useState } from 'react';
import {
    TextScript,
    useConfig
} from '@MGPD/myasurion-shared';

export interface CardContent {
    img: string;
    familyName: string;
    srf: string;
}

export interface CardsProps {
    cardContent: Array<CardContent>;
    onClickCallback?: (args: CardContent) => void;
    actualModel?: {
        img: string;
        familyName: string;
        srf: string;
    };
}

export const Cards: React.FC<PropsWithChildren<BoxProps & CardsProps>> = ({
    onClickCallback,
    children,
    cardContent,
    actualModel,
    ...props
}) => {
    const [visibleCards, setVisibleCards] = useState(6);
    const pageName = 'Cards';

    const { data } = useConfig();
    const { theme } = data;
    const { colors } = theme;

    const handleLoadMore = () => {
        setVisibleCards((prevVisibleCards) => prevVisibleCards + 6);
    };

    const camelize = function (str: string) {
        return str.replace(/\w+/g, function (match) {
            return match.charAt(0).toUpperCase() + match.slice(1);
        });
    };

    return (
        <Box {...props}>
            <SimpleGrid
                spacing={2}
                templateColumns={['repeat(2, 1fr)', 'repeat(auto-fill, minmax(200px, 1fr))']}
            >
                {cardContent?.map((val, index) => {
                    if (index < visibleCards) {
                        return (
                            <center key={index}>
                                <Card
                                    size={'sm'}
                                    borderWidth={
                                        val?.familyName === actualModel?.familyName ? '1px' : '1px'
                                    }
                                    borderColor={
                                        val?.familyName === actualModel?.familyName
                                            ? 'black'
                                            : '#A5AAAF'
                                    }
                                    borderRadius={'8px'}
                                    onClick={() => {
                                       onClickCallback && onClickCallback(val);
                                    }}
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '220px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {val?.familyName === actualModel?.familyName && (
                                        <Box
                                            position="absolute"
                                            top={'-12px'}
                                            left={'50%'}
                                            transform={'translateX(-50%)'}
                                            right={0}
                                            bg="white"
                                            color="black"
                                            fontWeight="bold"
                                            borderColor={'black'}
                                            borderWidth={'1px'}
                                            zIndex={2}
                                            paddingX={'8px'}
                                            paddingY={'2px'}
                                            width="max-content"
                                            fontSize={'12px'}
                                            textAlign="center"
                                            borderRadius={'4px'}
                                        >
                                            <TextScript
                                                text={'Your current model'}
                                                translationKey={`${pageName}/currentModel`}
                                            />
                                        </Box>
                                    )}
                                    <CardHeader paddingTop={'15px'}>
                                        <Image
                                            src={val.img}
                                            alt="loading"
                                            height={'100px'}
                                            width={'80px'}
                                        />
                                    </CardHeader>
                                    <CardBody paddingBottom={'4px'}>
                                        <Text fontWeight={'bold'} fontSize={'15px'}>
                                            {camelize(val?.familyName.toLowerCase())?.replace(
                                                /iphone/gi,
                                                'iPhone'
                                            )}
                                        </Text>
                                        <Text
                                            fontWeight={'light'}
                                            fontSize={'15px'}
                                            marginTop={'4px'}
                                        >
                                            {val.srf}
                                        </Text>
                                    </CardBody>
                                    {/* <CardFooter
                                        display={'flex'}
                                        justifyContent={'center'}
                                        marginTop={'-10px'}
                                        fontSize={'15px'}
                                    >
                                        {val.srf}
                                    </CardFooter> */}
                                </Card>
                            </center>
                        );
                    }
                    return null;
                })}
            </SimpleGrid>
            {visibleCards < cardContent?.length && (
                <center>
                    <Button
                        mt="4"
                        onClick={handleLoadMore}
                        display={'flex'}
                        justifyContent={'center'}
                        color={colors?.primary}
                        variant="outline"
                        paddingX={'12px'}
                    >
                        <TextScript
                            text={'Load more options'}
                            translationKey={`${pageName}/btnLoadMore`}
                        />
                    </Button>
                </center>
            )}
        </Box>
    );
};

export default Cards;